<ng-template #userGroupModalFormContent role="document" let-modal>

  <app-page-comp-header #pageHeader
    [showBottomBorder]="false"
    [title]="formTitle"
  >
  </app-page-comp-header>

  <form (ngSubmit)="userGroupFormSubmitAttempt()" [formGroup]="userGroupForm" class="tablelist-form" autocomplete="off" >
    <div class="modal-body" id="userGroupFormDetails">

      <!-- <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
              <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
              <span [innerHtml]="progressInformation"></span>
            </div>
          </div>
        </div>
      </div> -->

      @if(showUsersGrid()) {
        <div class="row"> 
          <div class="col-12">
            <div class="mb-3 border border-success rounded">
              <div class="row">
                <div class="col-12">
                  <div>
                    <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px" role="alert">
                      <strong>Group Details</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="mb-3 px-3">
                    <label for="groupName-field" class="form-label">Name</label>
                    <input autocomplete="no-fill" type="text" id="groupName-field" class="form-control" placeholder="" formControlName="groupName" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formOfuserGroupAdd['groupName'].errors }" />
                    @if(formOfuserGroupAdd['groupName'].hasError('maxlength')) {
                      <div class="invalid-feedback">Maximum length of {{nameMaxLength}} characters has been exceeded</div>
                    } @else {
                      <div class="invalid-feedback">A value is required</div>
                    }
                  </div>
                </div>  
              </div>
            </div>
          </div>
        </div>
      }
     
      @if(showUsersGrid()) {
        <div class="row"> 
          <div class="col-12">
            <div class="mb-3 border border-success rounded">
              <div class="row">
                <div class="col-12">
                  <div>
                    <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px;" role="alert">
                      <strong>User Allocation</strong>
                    </div>
                  </div>
                </div>
              </div>
                <div class="row"> 
                  <div class="col-12">
                    <div class="mb-0 px-3">
                      <app-grid-view #gridViewUsers
                        [apiPath]="dgApiPathUsers"
                        [dgActionColumn]="dgActionColumnUsers"
                        [dgColumns]="dgColumnsUsers"
                        [dgPopup]="dgPopupUsers"
                        [dgProperties]="dgPropertiesUsers"
                        [dgTabs]="dgTabsUsers"
                        (contentReady)="usersOnContentReady($event)"
                        (deleteButtonClick)="usersRemoveButtonClick($event)"
                        (editButtonClick)="usersIncludeButtonClick($event)"
                        (tabChanged)="usersOnTabChange($event)"
                      ></app-grid-view>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      } 
      @if(showGroupsGrid()) {
        <div class="row"> 
          <div class="col-12">
            <div class="mb-3 border border-success rounded" [ngClass]="{ 'is-invalid': formSubmitted && !userGroupValidation() }">
              <div class="row">
                <div class="col-12">
                  <div>
                    <div class="alert border-0 alert-primary" style="padding-top: 6px;padding-bottom: 6px;" role="alert">
                      <strong>User Group Allocation</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row"> 
                <div class="col-12">
                  <div class="mb-0 px-3">
                    <app-grid-view #gridViewGroups
                      [apiPath]="dgApiPathGroups"
                      [dgActionColumn]="dgActionColumnGroups"
                      [dgColumns]="dgColumnsGroups"
                      [dgPopup]="dgPopupGroups"
                      [dgProperties]="dgPropertiesGroups"
                      [dgTabs]="dgTabsGroups"
                      (contentReady)="groupsOnContentReady($event)"
                      (deleteButtonClick)="groupsRemoveButtonClick($event)"
                      (editButtonClick)="groupsIncludeButtonClick($event)"
                      (tabChanged)="groupsOnTabChange($event)"
                    ></app-grid-view>
                  </div>
                </div>
              </div>
            </div>
            <div class="invalid-feedback">At least one userGroup needs to be included</div>
          </div>
        </div>
      }
    </div>
    
    <div class="modal-footer">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="userGroupFormCancel()">Close</button>
              <button type="submit" [disabled]="!submitButtonEnabled" class="btn btn-success" id="add-btn-userGroup-edit">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>    

</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="userGroupCompletedModalHasBeenClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>

